import Head from "next/head";
import { Content, GoogleJobsSchema } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { getGlobal } from "@/functions/getGlobal";
import { jobs_helper } from "@/helpers/jobs_helper";
import { consultant_helper } from "@/helpers/consultant_helper"; 
import * as additionalComponents from "./__components";
import { createTitle } from "@/functions/createTitle";
import BackButton from "@/components/BackButton";
import JobDetail from "@/components/JobDetail";
import LatestJobs from "@/components/LatestJobs";
import classes from "./styles.module.scss";
import SeoHead from "@/components/SeoHead";
import { getContractType } from "@/functions/getContractType";
import { Cookies } from "@/components";

export default function JobPage({ job, all_jobs, consultant, content }) {
  const global = getGlobal();
  
  return (
    <>
      <main style={{marginTop: '200px'}}>
        <GoogleJobsSchema
          job={job}
          employment_type={getContractType(job.categories)}
          site_name={global["_theme.company.name"]}
          site_domain_link={global["_theme.company.domain"]}
          site_google_logo_link={global["_theme.company.logo"]}
        />
        <SeoHead
            page_name={`${job?.title} Job in ${job?.location} | Xcede`}
            description={`Apply today for ${job?.title} Job in ${job?.location}. View more great jobs from Xcede today `}
            canonical_link={`https://www.xcede.com/jobs/${job?.url_slug}`}
          />
        <div className={classes.cont}>
          <BackButton link="/jobs" />
          <JobDetail job={job} consultant={consultant ? consultant : {}} />
        </div>
        <LatestJobs jobs={all_jobs} title="Latest Jobs"></LatestJobs>
      </main>
      
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const job = jobs_helper.find(url_slug);
  const related = jobs_helper.fetch({ exclude: [job.id] }); // TODO filter by sector
  
	const all_jobs = jobs_helper.fetch().slice(0, 4);

  const consultant_category = job.categories.find(c => c.id === "6d357999-3024-4299-bacd-3aac7e36e953");
  const consultant_detail = consultant_category?.values.shift();
  const consultant_name = consultant_detail?.name;
  
  const consultant = consultant_helper.fetch({filter: (i) => (i.name == consultant_name)}).shift() ?? null;

  return {
    props: {
      meta: {
        title: createTitle(job.title),
      },
      job,
      all_jobs,
      consultant
    },
  };
}

export async function getStaticPaths() {
  return { paths: jobs_helper.toPaths(), fallback: false };
}
